module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"msg":{"text1":"Pilot Carbon Summary"}},"ar":{"msg":{"text1":" ملخص المنصة التجريبية الخاصة بتداول أرصدة الكربون"}}}')
  delete Component.options._Ctor
}
